module.exports = __webpack_public_path__ + "static/wave_two-8dd2164a7069b9c3895e6295bfc3cf8f.png";